const App = () => <div>Hello</div>;

export default App;
